import React, { useState, useEffect } from "react";

//librerias de microsoft
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../microsoft/authConfig";

//loaders
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { fechaAExcelNumero, excelAFecha } from "../../functions/functions.js";

import ReactECharts from "echarts-for-react";

function Example() {
  const { instance, accounts } = useMsal();

  //listado
  const [dataExcel, setDatosExcel] = useState([]);

  const [dataGrafica, setDataGrafica] = useState({
    fechas: [],
    oz_au_plan: [],
    oz_au_real_ocm: [],
  });

  //efecto de loading
  const [openLoader, setOpenLoader] = useState(true);

  useEffect(() => {
    loginAndFetchExcel();
  }, [instance, accounts]);

  useEffect(() => {
    if (dataExcel.length > 0) {
      setOpenLoader(false);
      console.log({ dataGrafica });
    }
  }, [dataExcel]);

  const loginAndFetchExcel = async () => {
    try {
      let account = instance.getActiveAccount();

      // Inicia sesión si no hay cuenta activa
      if (accounts.length === 0) {
        const loginResponse = await instance.loginPopup(loginRequest);
        account = loginResponse.account;
        console.log("Logueado como :", loginResponse.account.username);

        // Lo establece como cuenta activa
        instance.setActiveAccount(account);
      }

      //Obtiene el token
      const tokenResponse = await instance.acquireTokenSilent({
        ...loginRequest,
        account: account,
      });

      const accessToken = tokenResponse.accessToken;

      // Sitio de excel
      const response = await fetch(
        "https://graph.microsoft.com/v1.0/me/drive/root:/Graficas.xlsx:/workbook/worksheets('Hoja1')/usedRange",
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      const data = await response.json();
      const allRows = data.values;

      // Elimina los encabezados del excel:
      const excelRows = allRows.slice(1);

      //Filtramos por fecha del todo mes de julio 2025
      let fechaInicio = fechaAExcelNumero(2025, 7, 1);
      let fechaFinal = fechaAExcelNumero(2025, 7, 31);

      let _fechas = [];
      let _oz_au_plan = [];
      let _oz_au_real_ocm = [];

      //filtra los registros por fecha y añade una columna nueva (fecha string)
      const _datosExcel = excelRows
        .filter((row) => row[0] >= fechaInicio && row[0] <= fechaFinal)
        .map((row) => {
          const fechaStr = excelAFecha(row[0]);

          _fechas.push(fechaStr);
          _oz_au_plan.push(row[11]);
          _oz_au_real_ocm.push(row[12]);

          return { ...row };
        });

      setDatosExcel(_datosExcel);
      setDataGrafica({
        fechas: _fechas,
        oz_au_plan: _oz_au_plan,
        oz_au_real_ocm: _oz_au_real_ocm,
      });
    } catch (err) {
      console.error(err);
    }
  };

  const option = {
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "cross",
        crossStyle: {
          color: "#999",
        },
      },
    },
    toolbox: {
      feature: {
        dataView: { show: true, readOnly: false },
        magicType: { show: true, type: ["line", "bar"] },
        restore: { show: true },
        saveAsImage: { show: true },
      },
    },
    legend: {
      data: ["Oz Au_Plan", "Oz Au_Real_OCM", "Acumulado"],
    },
    xAxis: [
      {
        type: "category",
        data: dataGrafica.fechas, //aqui van a ir los dias
        axisPointer: {
          type: "shadow",
        },
      },
    ],
    yAxis: [
      {
        type: "value",
        name: "Oz Au_Plan",
        min: 0,
        max: 1400,
        interval: 200,
        axisLabel: {
          formatter: "{value} Oz Au",
        },
      },
      {
        type: "value",
        name: "Oz Au_Real_OCM",
        min: 0,
        max: 30000,
        interval: 5000,
        axisLabel: {
          formatter: "{value} Acumulado Plan Oz Au",
        },
      },
    ],
    series: [
      {
        name: "Oz Au_Plan",
        type: "bar",
        tooltip: {
          valueFormatter: function (value) {
            return value + " ml";
          },
        },
        data: dataGrafica.oz_au_plan,
      },
      // {
      //   name: "Oz Au_Real_OCM",
      //   type: "bar",
      //   tooltip: {
      //     valueFormatter: function (value) {
      //       return value + " ml";
      //     },
      //   },
      //   data: dataGrafica.oz_au_real_ocm,
      // },
      {
        name: 'Oz Au_Real_OCM',
        type: 'line',
        yAxisIndex: 1,
        tooltip: {
          valueFormatter: function (value) {
            return value + ' ml';
          }
        },
        data: dataGrafica.oz_au_real_ocm,
      }
    ],
  };

  return (
    <div className="p-4 rounded-lg shadow-lg  bg-blanco border-gray-600 mt-1 w-full">
      {/* Loader */}
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={openLoader}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <div style={{ width: "100%", height: 800 }}>
        <ReactECharts option={option} />
      </div>
    </div>
  );
}

export default Example;
